export const AUDITOR_FEE = 500
